import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchReviewsSummary,
  fetchReviews,
  createReview as createReviewService,
  updateReview as updateReviewService,
  deleteReview as deleteReviewService,
  fetchReviewById,
  forceDeleteReview as forceDeleteReviewService,
} from "./reviews.service";
import {
  ReviewsSummary,
  Review,
  ReviewDetail,
  CreateReviewPayload,
  UpdateReviewPayload,
} from "./reviews.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getReviewsSummary = createAsyncThunk<
  ReviewsSummary,
  void,
  { rejectValue: string }
>("reviews/getSummary", async (_, { rejectWithValue }) => {
  try {
    const response = await fetchReviewsSummary();
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getReviews = createAsyncThunk<
  Review[],
  string | undefined,
  { rejectValue: string }
>("reviews/getList", async (status, { rejectWithValue }) => {
  try {
    const response = await fetchReviews(status);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const addReview = createAsyncThunk<
  ReviewDetail,
  CreateReviewPayload,
  { rejectValue: string }
>("reviews/create", async (payload, { rejectWithValue }) => {
  try {
    const response = await createReviewService(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const editReview = createAsyncThunk<
  ReviewDetail,
  UpdateReviewPayload,
  { rejectValue: string }
>("reviews/update", async (payload, { rejectWithValue }) => {
  try {
    const response = await updateReviewService(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const removeReview = createAsyncThunk<
  number,
  number,
  { rejectValue: string }
>("reviews/delete", async (id, { rejectWithValue }) => {
  try {
    await deleteReviewService(id);
    return id;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getReviewById = createAsyncThunk<
  ReviewDetail,
  number,
  { rejectValue: string }
>("reviews/getById", async (id, { rejectWithValue }) => {
  try {
    const response = await fetchReviewById(id);
    return response.data;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const forceRemoveReview = createAsyncThunk<
  number,
  number,
  { rejectValue: string }
>("reviews/forceDelete", async (id, { rejectWithValue }) => {
  try {
    await forceDeleteReviewService(id);
    return id;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});